import BracketOracleDefinition from "./BracketOracle.abi.json";
import ERC20Definition from "./ERC20.abi.json";
import EscrowDefintion from "./Escrow.abi.json";
import PricingDefinition from "./Pricing.abi.json";
import UniswapQuoterV3Definition from "./UniswapQuoterV3.abi.json";
import UniswapV3FactoryDefinition from "./UniswapV3Factory.abi.json";
import BracketVaultDefinition from "./BracketVault.abi.json";
import BracketVaultFactoryDefinition from "./BracketVaultFactory.abi.json";
import BrktETHDefinition from "./BrktETH.abi.json";
import BracketEscrowDefinition from "./BracketEscrow.abi.json";
import BTCUSDDefinition from "./BTC_USD.abi.json";
import ETHUSDDefintiion from "./ETH_USD.abi.json";
import EscrowRouterDefinition from "./EscrowRouter.abi.json";
import UniswapV3SwapRouterDefinition from "./UniswapV3SwapRouter.abi.json";
import BrktETHSwapRouterDefinition from "./BrktETHSwapRouter.abi.json";
import BracketVaultV2Definition from "./BracketVaultV2.abi.json";
import BracketVaultFactoryV2Definition from "./BracketVaultFactoryV2.abi.json";
import TestContractDefinition from "./TestContract.abi.json";
import TestContractV2Definition from "./TestContractV2.abi.json";
import BrktETHRouterDefinition from "./BrktETHRouter.abi.json";
import BracketWrappedVaultDefinition from "./BracketWrappedVault.abi.json";
export const BracketOracle = BracketOracleDefinition;
export const ERC20 = ERC20Definition;
export const Escrow = EscrowDefintion;
export const Pricing = PricingDefinition;
export const UniswapQuoterV3 = UniswapQuoterV3Definition;
export const UniswapV3Factory = UniswapV3FactoryDefinition;
export const BracketVaultFactory = BracketVaultFactoryDefinition;
export const BrktETH = BrktETHDefinition;
export const BRKTETH = BrktETH;
export const BracketEscrow = BracketEscrowDefinition;
export const BracketVault = BracketVaultDefinition;
export const BTC_USD = BTCUSDDefinition;
export const ETH_USD = ETHUSDDefintiion;
export const EscrowRouter = EscrowRouterDefinition;
export const UniswapV3SwapRouter = UniswapV3SwapRouterDefinition;
export const BrktETHSwapRouter = BrktETHSwapRouterDefinition;
export const BracketVaultV2 = BracketVaultV2Definition;
export const BracketVaultFactoryV2 = BracketVaultFactoryV2Definition;
export const TestContract = TestContractDefinition;
export const TestContractV2 = TestContractV2Definition;
export const BrktETHRouter = BrktETHRouterDefinition;
export const BracketWrappedVault = BracketWrappedVaultDefinition;
